export const translations = {
  en: {
    lang_label: "FR",
    motto: "L'école de L'avenir",
    school: "Institution Chrétienne d'Haïti",
    nav: {
      home: "Home",
      about: "Our School",
      why: "Why ICDH",
      stem: "STEM Library",
      portal_demo: "Portal",
      programs: "Programs",
      professional: "Professional",
      admissions: "Admission",
      news: "News",
      gallery: "Gallery",
      alumni: "Alumni",
      contact: "Contact",
      careers: "Careers",
      donate: "Donate",
      apply: "Apply Now",
      login: "Log in",
      portal: "My Portal",
      admin: "Admin",
    },
    hero: {
      overline: "Est. 2000 · Port-au-Prince, Haïti",
      l1: "Forming minds,",
      l2: "shaping character,",
      l3: "building the future.",
      sub: "A bilingual education with two distinct programs: the National program, which follows the curriculum of the Ministry of National Education, and the International program, focused on technology (STEM), from Chez Kids kindergarten to New Secondary 4. Every student takes 100% of their courses on their tablet, and is encouraged and inspired to become a leader of tomorrow.",
      cta1: "Begin Admission",
      cta2: "Discover ICDH",
    },
    marquee: ["Faith", "Excellence", "Bilingual", "Innovation", "Community", "Discipline", "Character", "STEM"],
    about: {
      overline: "Our School",
      title: "Twenty-five years of forming Haiti's next generation.",
      lead: "A bilingual education offering two distinct programs — National and International — focused on STEM technologies, from Chez Kids kindergarten through New Secondary 4, where every student, tablet in hand, is recognized, encouraged and inspired to become a leader of tomorrow.",
      body_1: "ICDH is a comprehensive school ranging from kindergarten (Chez Kids) through New Secondary 4 (high school), offering a multitude of successful, one-of-a-kind educational opportunities. Our innovative, high-quality programs complement a rigorous, traditional curriculum, delivered by top-notch educators who genuinely care about each and every student.",
      body_2: "Our mission is to create an environment that inspires students to achieve their full potential, equips them with the tools necessary for future success, and promotes the importance of contributing to the global community.",
      body_3: "The school has played an important role in the development of young people in Haiti. Our beautiful campus was destroyed in the devastating earthquake of January 12, 2010 — and through rigorous discipline and hard work, we rebuilt it stone by stone.",
      chapters: [
        { n: "2000", t: "Founded by educators", d: "The Joseph brothers brought their New York City Board of Education experience home to Haiti, opening ICDH as a truly comprehensive, bilingual Christian school." },
        { n: "2012", t: "FBLA Haiti Chapter", d: "We established the Future Business Leaders of America Haiti Chapter. Each year we prepare students to compete in the United States in public speaking, customer service, and accounting." },
        { n: "2025", t: "STEM & LMS launched", d: "Every student uses a tablet with high-speed Internet; every classroom is equipped with a smart TV. Innovation, arts, and sciences hone 21st-century skills." },
      ],
      stats: [
        { n: "100%", t: "State exam pass rate since 2016" },
        { n: "25+", t: "Years shaping Haiti's future" },
        { n: "K–NS4", t: "From Chez Kids to graduation" },
      ],
    },
    why: {
      overline: "Why choose ICDH?",
      title: "At ICDH, educational excellence at your fingertips",
      intro: "As technology transforms education, Institution Chrétienne d'Haïti (ICDH) stands as a pioneer of innovation with its new Integrated School Portal — keeping the whole community synchronized, seamless and, above all, secure.",
      features: [
        { icon: "shield", t: "Digital safety, guaranteed by parents", d: "Student tablets are carefully managed by parents. Strict parental controls prevent any drift toward inappropriate sites — our children devote their time to learning and discovery, far from social-media distractions." },
        { icon: "book", t: "The STEM digital library", d: "Far more than a file repository, it is a living extension of the classroom. A strong focus on STEM — science, technology, engineering and math — plus foreign languages, fascinating science tips, and lessons and videos available anytime for effective, safe revision." },
        { icon: "tablet", t: "An integrated school portal", d: "Synchronized, secure information connecting parents, teachers and students. Technology in harmony with our Christian values, preparing our youth for international standards." },
      ],
      benefits_title: "Benefits for everyone",
      benefits: [
        { icon: "parents", t: "For parents", d: "Peace of mind and visibility: track grades, absences and payments (Zelle) in real time, with direct communication with the administration." },
        { icon: "teachers", t: "For teachers", d: "Efficiency and integrity: with the lesson planner and secure grade entry, teachers focus on what matters most — teaching." },
        { icon: "students", t: "For students", d: "Autonomy and modernity: the portal prepares our youth for international standards, teaching them to manage their time through immediate interactive feedback." },
      ],
      closing: "At ICDH, we bring technology into harmony with our Christian values to give your children the best possible future. Secure information for guaranteed success.",
      free_badge: "ENROLLMENT IS FREE",
      cta_stem: "Explore the STEM Library",
      cta_enroll: "Enroll my child now",
    },
    stem: {
      overline: "STEM Digital Library",
      title: "An immersive world of science, languages and discovery",
      lead: "A living extension of the classroom. Watch, learn and revise anytime — with a strong focus on science, technology, engineering, mathematics and languages.",
      back: "Back to home",
      watch: "Watch",
      now_playing: "Now playing",
      cta_enroll: "Enroll my child now",
    },
    portal: {
      overline: "Portal Demonstration",
      title: "Follow your child's progress — and pay in a tap",
      lead: "The ICDH Integrated School Portal keeps parents informed in real time: grades, attendance and secure payments by Zelle.",
      steps_title: "How it works for parents",
      steps: [
        { t: "Sign in to the portal", d: "Access your secure parent dashboard from any device." },
        { t: "Track grades & attendance", d: "See report cards, results and absences updated in real time." },
        { t: "Pay tuition via Zelle", d: "Settle fees securely with Zelle — no cash, no queues." },
      ],
      device_label: "Parent Dashboard",
      grades_title: "Report card",
      grades: [
        { s: "Mathematics", g: "A" },
        { s: "Sciences", g: "A-" },
        { s: "French", g: "B+" },
        { s: "English", g: "A" },
      ],
      attendance: "Attendance",
      present: "98% present",
      pay_title: "Tuition payment",
      pay_amount: "Amount due",
      pay_with: "Pay with Zelle",
      pay_note: "Secure payment · Zelle to icdh@ecoleicdh.org",
    },
    programs: {
      overline: "Academics",
      title: "Programs for every stage of the journey.",
      items: [
        { t: "Chez Kids", d: "Kindergarten. A caring, playful foundation in language, numbers and social skills — where our youngest learners begin their ICDH story.", n: "Preschool" },
        { t: "Primary School", d: "Grades 1–6. Core literacy, numeracy, and discovery delivered in both French and English, with STEM built in from grade 1.", n: "Fondamental" },
        { t: "Secondary School", d: "Grades 7 through New Secondary 4. Rigorous preparation for the state exam — where our graduates have held a 100% pass rate since 2016.", n: "Secondaire" },
        { t: "Faith & Arts", d: "Chapel, music, visual arts, and service. Character formation grounded in Christian values shapes the whole person.", n: "Enrichment" },
      ],
    },
    professional: {
      overline: "Professional Program",
      title: "Pioneers in professional preparation.",
      lead: "Beyond our core academic program, ICDH prepares students for global opportunity through certified tracks.",
      items: [
        { t: "2-Year IELTS Program", d: "We are pioneers in helping students from schools across Haiti achieve their goals through our two-year IELTS preparation program." },
        { t: "STEM (Grades 1–5)", d: "Launched in 2025. Students are evaluated in both English and the national Haitian-French curriculum — bridging two worlds of learning." },
        { t: "Learning Management System", d: "Every student has a tablet with high-speed Internet. Every classroom features a smart TV. Special online courses through our LMS." },
        { t: "Professional Certificates", d: "We are in the process of providing additional professional certificates through online courses — expanding what an ICDH diploma opens up." },
      ],
    },
    admissions: {
      overline: "Admission",
      title: "Join the ICDH family.",
      lead: "Registrations are being received for classes from Kindergarten to New Secondary 4 (High School Level). Please fill in the registration form below and submit it along with a photo of the student and parent.",
      docs_title: "Required documents",
      docs: [
        "Birth certificate or extract from the archives (original) — Passport",
        "Report card from the last stage of the last school attended",
        "Medical certificate attesting to the compulsory vaccinations, issued by the child's pediatrician",
        "Parents' valid government-issued IDs",
        "Parent's representative ID",
      ],
      late_title: "Late admission",
      late_body: "Admission to ICDH is easy — simply show up at the appointment set for registration with your documents. We admit students on a temporary basis if all documents (such as the original birth certificate, archive paper, or official report card) are not yet available.",
      steps: ["Submit your inquiry", "Campus visit & assessment", "Enrollment & welcome"],
      form: {
        name: "Full name (parent)",
        email: "Email",
        phone: "Phone",
        student_name: "Student full name",
        program: "Class requested",
        program_placeholder: "Select a class",
        student_photo: "Student photo",
        parent_photo: "Parent photo",
        documents: "Supporting documents (birth certificate, report card, vaccination record…)",
        documents_hint: "You may upload multiple files · JPG, PNG, HEIC or PDF · 15 MB max each",
        uploading: "Uploading…",
        upload_cta: "Choose file",
        upload_cta_multi: "Add file(s)",
        required_photo: "Required",
        message: "Tell us about your child",
        submit: "Submit application",
        sending: "Sending…",
        success_title: "Application received",
        success: "Thank you! Our admissions team will contact you shortly.",
        success_body: "We've received your application for {student}. A confirmation email has been sent to {email}. Our admissions office will reach out within 2 business days.",
        err_missing_student_photo: "Please upload a photo of the student.",
        err_missing_parent_photo: "Please upload a photo of the parent.",
        err_file_too_large: "File too large (15 MB max).",
        err_upload: "Upload failed, please try again.",
        close: "Close",
      },
      classes: ["Chez Kids (Kindergarten)", "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6", "Grade 7 / 1st Secondary", "Grade 8 / 2nd Secondary", "Grade 9 / 3rd Secondary", "New Secondary 1", "New Secondary 2", "New Secondary 3", "New Secondary 4"],
    },
    news: { overline: "News & Events", title: "Life at ICDH.", empty: "No articles yet.", read: "Read more", event: "Event", back: "Back" },
    gallery: { overline: "Gallery", title: "Moments that define us." },
    alumni: {
      overline: "Alumni",
      title: "Once ICDH, always ICDH.",
      lead: "Register here with your photo and your story. We need your accomplishments to inspire our young students — and your support to keep the mission alive.",
      cta: "Register as Alumni",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        grad_year: "Graduation year",
        current_role: "Current role / profession",
        location: "City & country",
        photo: "Your photo",
        photo_hint: "A clear portrait · JPG/PNG/HEIC · 15 MB max",
        story: "Your story — what you studied, where you are now, how ICDH shaped you",
        story_placeholder: "Share a short story (3-6 sentences) that could inspire today's ICDH students.",
        submit: "Submit my profile",
        sending: "Sending…",
        success: "Thank you! Welcome back to the ICDH family — we'll be in touch.",
        err_missing_photo: "Please upload a photo for your profile.",
      },
    },
    careers: {
      overline: "Careers",
      title: "Join the ICDH team.",
      lead: "We are always looking for passionate teachers and dedicated service staff. Send us your application and our team will get back to you.",
      role_label: "I am applying as",
      role_teacher: "Teacher",
      role_staff: "Service staff",
      grade_label: "Grade level (teachers)",
      grade_placeholder: "e.g., Grade 5, New Secondary 4",
      subject_label: "Subject taught (teachers)",
      subject_placeholder: "e.g., Mathematics, Biology, French",
      resume_label: "Resume / CV link",
      resume_placeholder: "Paste a link to your CV (Google Drive, LinkedIn, Dropbox…)",
      resume_hint: "We accept a public link to your CV for now. Direct file upload is coming soon.",
      message_placeholder: "Tell us why you'd be a great fit for ICDH…",
      submit: "Send Application",
      success: "Application received. Our team will be in touch shortly.",
      err_link: "Please provide a valid CV link starting with http(s)://",
    },
    donate: {
      overline: "Support ICDH",
      title: "Give a child a future — donate or sponsor a student.",
      lead: "Every gift helps us buy tablets, fund the STEM lab and keep tuition within reach. Sponsor a specific student or donate to the general fund. ICDH is a 501(c)(3) non-profit organization — your contribution is tax-deductible.",
      pay_now: "Pay now via Zelle",
      pay_hint: "Scan the QR code with your Zelle app, then send confirmation to icdhhaiti@gmail.com — or via WhatsApp at +509 34 33 21 33.",
      or: "Or leave your details",
      type_label: "I would like to",
      type_donation: "Make a donation",
      type_sponsor: "Sponsor a student",
      amount_label: "Amount (USD or HTG)",
      amount_placeholder: "e.g., 100 USD, 5000 HTG",
      student_label: "Student's name (if sponsoring)",
      student_placeholder: "Full name or grade level",
      message_placeholder: "Your message (optional)",
      submit: "Send my pledge",
      success: "Thank you! We will reach out with next steps.",
    },
    contact: {
      overline: "Contact",
      title: "We'd love to hear from you.",
      email: "icdh@ecoleicdh.org", email2: "icdhhaiti@gmail.com",
      locations: [
        { name: "Head Office · Haïti", address: "34 Mahotière 83, Carrefour, Port-au-Prince, Haïti", phone: "+509 34 33 21 33" },
        { name: "ICDH Plaza · Haïti", address: "Ruelle Baguidy (opposite Côte Plage 16) — ICDH Plaza, Carrefour", phone: "+509 34 33 21 33" },
        { name: "USA Office", address: "2910 Glenwood Road, Brooklyn, NY 11210, USA", phone: "+1 (718) 421-3349" },
      ],
      form: { name: "Name", email: "Email", message: "Message", submit: "Send Message", success: "Message sent. Thank you!" },
    },
    footer: {
      tagline: "Forming the leaders of tomorrow.",
      rights: "All rights reserved.",
      quick: "Explore",
      contact: "Contact",
      partners: "Partners & Press",
    },
    parents: {
      title: "Parents & Students Portal",
      welcome: "Welcome",
      subtitle: "Access your student's account, invoices, grades and school communication.",
      pay_title: "Pay Tuition via Zelle",
      pay_body: "Scan the QR code below with your Zelle app to complete tuition payment. Send confirmation to icdhhaiti@gmail.com.",
      scan: "Scan to pay",
      invoice: { t: "Tuition Invoice", d: "Your latest invoice will appear here once posted by the finance office." },
      grades: { t: "Grades & Unofficial Transcript", d: "Your student's most recent grades and unofficial transcript." },
      projects: { t: "Projects", d: "List of active projects and assignments." },
      reminders: { t: "Reminders & Notes", d: "Notes and reminders from teachers and administration." },
      homework: { t: "Homework (Students)", d: "Log in to see teacher homework and pertinent information." },
      message_title: "Message the school",
      message_placeholder: "Write to the administration or your student's teacher…",
      pending: "Coming soon — the school will publish content here shortly.",
      admin_link: "Go to Admin Dashboard",
      logout: "Log out",
      broadcasts_title: "School notices",
      broadcasts_empty: "No notices from the school yet.",
      from_school: "From the school",
    },
    login: {
      title: "Log in",
      sub: "Parents, students and staff.",
      email: "Email",
      password: "Password",
      submit: "Sign In",
      back: "Back to site",
    },
  },
  fr: {
    lang_label: "EN",
    motto: "L'école de L'avenir",
    school: "Institution Chrétienne d'Haïti",
    nav: {
      home: "Accueil",
      about: "Notre École",
      why: "Pourquoi ICDH",
      stem: "Bibliothèque STEM",
      portal_demo: "Portail",
      programs: "Programmes",
      professional: "Professionnel",
      admissions: "Admission",
      news: "Actualités",
      gallery: "Galerie",
      alumni: "Anciens",
      contact: "Contact",
      careers: "Carrières",
      donate: "Faire un don",
      apply: "S'inscrire",
      login: "Connexion",
      portal: "Mon Portail",
      admin: "Admin",
    },
    hero: {
      overline: "Fondée en 2000 · Port-au-Prince, Haïti",
      l1: "Former les esprits,",
      l2: "façonner le caractère,",
      l3: "bâtir l'avenir.",
      sub: "Une éducation bilingue avec deux programmes distincts : le programme national, qui suit le curriculum du Ministère de l'Éducation nationale, et le programme international, axé sur la technologie (STEM), de la maternelle Chez Kids jusqu'au Nouveau Secondaire 4. Chaque élève suit 100 % des cours sur sa tablette, et est encouragé et inspiré à devenir un leader de demain.",
      cta1: "Commencer l'admission",
      cta2: "Découvrir ICDH",
    },
    marquee: ["Foi", "Excellence", "Bilingue", "Innovation", "Communauté", "Discipline", "Caractère", "STEM"],
    about: {
      overline: "Notre École",
      title: "Vingt-cinq ans à former la prochaine génération d'Haïti.",
      lead: "Une éducation bilingue proposant deux programmes distincts : National et International, axée sur les technologies STEM, allant de la maternelle (Chez Kids) jusqu'au Nouveau Secondaire 4 — où chaque élève, muni de sa tablette, est reconnu, encouragé et inspiré à devenir un leader de demain.",
      body_1: "ICDH est une école complète allant du jardin d'enfants (Chez Kids) au Nouveau Secondaire 4 (lycée), offrant une multitude d'opportunités éducatives uniques et réussies. Nos programmes innovants et de haute qualité complètent un curriculum rigoureux et traditionnel, dispensé par des éducateurs de premier plan qui se soucient sincèrement de chaque élève.",
      body_2: "Notre mission est de créer un environnement qui inspire les élèves à atteindre leur plein potentiel, leur fournit les outils nécessaires à leur réussite future et promeut l'importance de contribuer à la communauté mondiale.",
      body_3: "L'école a joué un rôle important dans le développement des jeunes en Haïti. Notre magnifique campus a été détruit lors du tremblement de terre dévastateur du 12 janvier 2010 — et grâce à une discipline rigoureuse et au travail acharné, nous l'avons reconstruit pierre par pierre.",
      chapters: [
        { n: "2000", t: "Fondée par des éducateurs", d: "Les frères Joseph ont ramené en Haïti leur expérience du New York City Board of Education, ouvrant ICDH comme une véritable école chrétienne bilingue et complète." },
        { n: "2012", t: "Chapitre FBLA Haïti", d: "Nous avons établi le chapitre haïtien des Future Business Leaders of America. Chaque année, nous préparons des élèves à concourir aux États-Unis en art oratoire, service client et comptabilité." },
        { n: "2025", t: "STEM & LMS lancés", d: "Chaque élève dispose d'une tablette avec Internet haut débit ; chaque salle de classe est équipée d'une smart TV. Innovation, arts et sciences pour affûter les compétences du 21e siècle." },
      ],
      stats: [
        { n: "100%", t: "Taux de réussite à l'examen d'État depuis 2016" },
        { n: "25+", t: "Années à façonner l'avenir d'Haïti" },
        { n: "M–NS4", t: "De Chez Kids à la remise des diplômes" },
      ],
    },
    why: {
      overline: "Pourquoi choisir l'ICDH ?",
      title: "À l'ICDH, l'excellence pédagogique à portée de main",
      intro: "À l'heure où la technologie bouleverse l'éducation, l'Institution Chrétienne d'Haïti (ICDH) se positionne comme pionnière de l'innovation grâce à son nouveau Portail Scolaire Intégré. Ce portail assure à toute la communauté une information synchronisée, fluide et surtout sécurisée.",
      features: [
        { icon: "shield", t: "Une sécurité numérique garantie par les parents", d: "Les tablettes des élèves sont scrupuleusement gérées par les parents. Ce contrôle parental strict évite tout dérapage vers des sites non conformes : nos enfants consacrent leur temps à apprendre et à découvrir, loin des distractions des réseaux sociaux." },
        { icon: "book", t: "La bibliothèque numérique STEM", d: "Bien plus qu'un dépôt de fichiers, c'est une extension vivante de la classe. Un accent particulier sur le STEM — sciences, technologie, ingénierie et mathématiques — ainsi que langues étrangères, astuces scientifiques, cours et vidéos accessibles à toute heure pour une révision efficace et sécurisée." },
        { icon: "tablet", t: "Un portail scolaire intégré", d: "Une information synchronisée et sécurisée qui relie parents, professeurs et élèves. La technologie mise en harmonie avec nos valeurs chrétiennes, pour préparer nos jeunes aux normes internationales." },
      ],
      benefits_title: "Les bénéfices pour chaque partie",
      benefits: [
        { icon: "parents", t: "Pour les parents", d: "Tranquillité et visibilité : suivez en temps réel les notes, les absences et les paiements (Zelle), avec une communication directe avec l'administration." },
        { icon: "teachers", t: "Pour les professeurs", d: "Efficacité et intégrité : grâce au planificateur de cours et à l'entrée sécurisée des notes, les professeurs se concentrent sur leur cœur de métier : enseigner." },
        { icon: "students", t: "Pour les élèves", d: "Autonomie et modernité : le portail les prépare aux normes internationales, en leur apprenant à gérer leur temps grâce à une rétroaction interactive immédiate." },
      ],
      closing: "À l'ICDH, nous mettons la technologie en harmonie avec nos valeurs chrétiennes pour offrir à vos enfants le meilleur avenir possible. Une information sécurisée pour une réussite garantie.",
      free_badge: "LES INSCRIPTIONS SONT GRATUITES",
      cta_stem: "Découvrir la Bibliothèque STEM",
      cta_enroll: "Inscrire mon enfant maintenant",
    },
    stem: {
      overline: "Bibliothèque numérique STEM",
      title: "Un univers immersif de sciences, langues et découvertes",
      lead: "Une extension vivante de la classe. Regardez, apprenez et révisez à toute heure — avec un accent fort sur les sciences, la technologie, l'ingénierie, les mathématiques et les langues.",
      back: "Retour à l'accueil",
      watch: "Regarder",
      now_playing: "Lecture en cours",
      cta_enroll: "Inscrire mon enfant maintenant",
    },
    portal: {
      overline: "Démonstration du portail",
      title: "Suivez la progression de votre enfant — et payez en un clic",
      lead: "Le Portail Scolaire Intégré de l'ICDH tient les parents informés en temps réel : notes, présences et paiements sécurisés par Zelle.",
      steps_title: "Comment ça marche pour les parents",
      steps: [
        { t: "Connectez-vous au portail", d: "Accédez à votre espace parent sécurisé depuis n'importe quel appareil." },
        { t: "Suivez notes & présences", d: "Consultez bulletins, résultats et absences mis à jour en temps réel." },
        { t: "Payez la scolarité via Zelle", d: "Réglez les frais en toute sécurité avec Zelle — sans espèces, sans file d'attente." },
      ],
      device_label: "Espace Parent",
      grades_title: "Bulletin de notes",
      grades: [
        { s: "Mathématiques", g: "A" },
        { s: "Sciences", g: "A-" },
        { s: "Français", g: "B+" },
        { s: "Anglais", g: "A" },
      ],
      attendance: "Assiduité",
      present: "98% de présence",
      pay_title: "Paiement de la scolarité",
      pay_amount: "Montant dû",
      pay_with: "Payer avec Zelle",
      pay_note: "Paiement sécurisé · Zelle vers icdh@ecoleicdh.org",
    },
    programs: {
      overline: "Académique",
      title: "Des programmes pour chaque étape du parcours.",
      items: [
        { t: "Chez Kids", d: "Maternelle. Une base bienveillante et ludique en langage, calcul et sociabilité — où nos plus jeunes élèves commencent leur histoire à ICDH.", n: "Préscolaire" },
        { t: "École Primaire", d: "1re à 6e année. Lecture, calcul et découverte en français et en anglais, avec STEM intégré dès la 1re année.", n: "Fondamental" },
        { t: "École Secondaire", d: "7e année au Nouveau Secondaire 4. Préparation rigoureuse à l'examen d'État — nos diplômés maintiennent un taux de réussite de 100% depuis 2016.", n: "Secondaire" },
        { t: "Foi & Arts", d: "Chapelle, musique, arts visuels et service. Formation du caractère fondée sur les valeurs chrétiennes qui façonne toute la personne.", n: "Enrichissement" },
      ],
    },
    professional: {
      overline: "Programme Professionnel",
      title: "Pionniers de la préparation professionnelle.",
      lead: "Au-delà de notre programme académique de base, ICDH prépare les élèves aux opportunités mondiales à travers des filières certifiées.",
      items: [
        { t: "Programme IELTS 2 ans", d: "Nous sommes pionniers dans l'accompagnement d'élèves d'écoles à travers Haïti pour atteindre leurs objectifs via notre programme de préparation IELTS de deux ans." },
        { t: "STEM (1re à 5e année)", d: "Lancé en 2025. Les élèves sont évalués à la fois en anglais et selon le curriculum national haïtien-français — un pont entre deux mondes d'apprentissage." },
        { t: "Système de gestion de l'apprentissage", d: "Chaque élève a une tablette avec Internet haut débit. Chaque classe dispose d'une smart TV. Des cours en ligne spéciaux via notre LMS." },
        { t: "Certificats professionnels", d: "Nous sommes en train de proposer des certificats professionnels supplémentaires via des cours en ligne — élargissant les portes qu'un diplôme ICDH ouvre." },
      ],
    },
    admissions: {
      overline: "Admission",
      title: "Rejoignez la famille ICDH.",
      lead: "Les inscriptions sont ouvertes pour les classes de la maternelle au Nouveau Secondaire 4 (niveau Lycée). Veuillez remplir le formulaire d'inscription ci-dessous et le soumettre avec une photo de l'élève et du parent.",
      docs_title: "Documents requis",
      docs: [
        "Extrait de naissance ou extrait des archives (original) — Passeport",
        "Bulletin scolaire de la dernière étape de la dernière école fréquentée",
        "Certificat médical attestant des vaccins obligatoires, émis par le pédiatre de l'enfant",
        "Pièces d'identité valides des parents",
        "Pièce d'identité du représentant du parent",
      ],
      late_title: "Admission tardive",
      late_body: "L'admission à ICDH est facile — présentez-vous au rendez-vous fixé pour l'inscription avec vos documents. Nous admettons les élèves de manière temporaire si tous les documents (extrait de naissance original, papier d'archive ou bulletin officiel) ne sont pas encore disponibles.",
      steps: ["Envoyez votre demande", "Visite du campus & évaluation", "Inscription & bienvenue"],
      form: {
        name: "Nom complet du parent",
        email: "Courriel",
        phone: "Téléphone",
        student_name: "Nom et prénom de l'élève",
        program: "Classe demandée",
        program_placeholder: "Sélectionnez une classe",
        student_photo: "Photo de l'élève",
        parent_photo: "Photo du parent",
        documents: "Documents requis (acte de naissance, bulletin, carnet de vaccins…)",
        documents_hint: "Vous pouvez téléverser plusieurs fichiers · JPG, PNG, HEIC ou PDF · 15 Mo max chacun",
        uploading: "Téléversement…",
        upload_cta: "Choisir un fichier",
        upload_cta_multi: "Ajouter un ou plusieurs fichiers",
        required_photo: "Obligatoire",
        message: "Parlez-nous de votre enfant",
        submit: "Soumettre la demande",
        sending: "Envoi en cours…",
        success_title: "Candidature reçue",
        success: "Merci ! Notre équipe des admissions vous contactera sous peu.",
        success_body: "Nous avons bien reçu la demande d'inscription pour {student}. Un courriel de confirmation a été envoyé à {email}. Notre bureau des admissions vous recontactera sous 2 jours ouvrables.",
        err_missing_student_photo: "Veuillez téléverser une photo de l'élève.",
        err_missing_parent_photo: "Veuillez téléverser une photo du parent.",
        err_file_too_large: "Fichier trop volumineux (15 Mo max).",
        err_upload: "Échec du téléversement, veuillez réessayer.",
        close: "Fermer",
      },
      classes: ["Chez Kids (Maternelle)", "1re année", "2e année", "3e année", "4e année", "5e année", "6e année", "7e année / 1re secondaire", "8e année / 2e secondaire", "9e année / 3e secondaire", "Nouveau Secondaire 1", "Nouveau Secondaire 2", "Nouveau Secondaire 3", "Nouveau Secondaire 4"],
    },
    news: { overline: "Actualités & Événements", title: "La vie à ICDH.", empty: "Aucun article pour le moment.", read: "Lire la suite", event: "Événement", back: "Retour" },
    gallery: { overline: "Galerie", title: "Les moments qui nous définissent." },
    alumni: {
      overline: "Anciens Élèves",
      title: "Une fois ICDH, toujours ICDH.",
      lead: "Inscrivez-vous ici avec votre photo et votre histoire. Nous avons besoin de vos réalisations pour inspirer nos jeunes élèves — et de votre soutien pour maintenir la mission.",
      cta: "S'inscrire comme ancien élève",
      form: {
        name: "Nom complet",
        email: "Courriel",
        phone: "Téléphone (facultatif)",
        grad_year: "Année de promotion",
        current_role: "Poste / profession actuel(le)",
        location: "Ville et pays",
        photo: "Votre photo",
        photo_hint: "Un portrait clair · JPG/PNG/HEIC · 15 Mo max",
        story: "Votre histoire — ce que vous avez étudié, où vous êtes aujourd'hui, comment ICDH vous a façonné(e)",
        story_placeholder: "Partagez une courte histoire (3 à 6 phrases) qui pourrait inspirer les élèves actuels d'ICDH.",
        submit: "Soumettre mon profil",
        sending: "Envoi en cours…",
        success: "Merci ! Bienvenue à nouveau dans la famille ICDH — nous vous recontacterons.",
        err_missing_photo: "Veuillez téléverser une photo pour votre profil.",
      },
    },
    careers: {
      overline: "Carrières",
      title: "Rejoignez l'équipe ICDH.",
      lead: "Nous recherchons des enseignants passionnés et un personnel de service dévoué. Envoyez-nous votre candidature — notre équipe vous recontactera.",
      role_label: "Je postule comme",
      role_teacher: "Enseignant(e)",
      role_staff: "Personnel de service",
      grade_label: "Niveau de classe (enseignants)",
      grade_placeholder: "Ex. : 5e année, Nouveau Secondaire 4",
      subject_label: "Matière enseignée (enseignants)",
      subject_placeholder: "Ex. : Mathématiques, Biologie, Français",
      resume_label: "Lien vers votre CV",
      resume_placeholder: "Collez un lien vers votre CV (Google Drive, LinkedIn, Dropbox…)",
      resume_hint: "Pour l'instant, nous acceptons un lien public vers votre CV. Le téléchargement direct de fichier arrive bientôt.",
      message_placeholder: "Dites-nous pourquoi vous seriez un atout pour ICDH…",
      submit: "Envoyer ma candidature",
      success: "Candidature reçue. Notre équipe vous contactera sous peu.",
      err_link: "Veuillez fournir un lien de CV valide commençant par http(s)://",
    },
    donate: {
      overline: "Soutenir ICDH",
      title: "Offrez un avenir à un enfant — faites un don ou parrainez un élève.",
      lead: "Chaque don nous aide à acheter des tablettes, à financer le laboratoire STEM et à maintenir des frais accessibles. Parrainez un élève précis ou contribuez au fonds général. ICDH est un organisme à but non lucratif 501(c)(3) — votre contribution est déductible d'impôts.",
      pay_now: "Payer maintenant via Zelle",
      pay_hint: "Scannez le code QR avec votre application Zelle, puis envoyez la confirmation à icdhhaiti@gmail.com — ou via WhatsApp au +509 34 33 21 33.",
      or: "Ou laissez-nous vos coordonnées",
      type_label: "Je souhaite",
      type_donation: "Faire un don",
      type_sponsor: "Parrainer un élève",
      amount_label: "Montant (USD ou HTG)",
      amount_placeholder: "Ex. : 100 USD, 5000 HTG",
      student_label: "Nom de l'élève (si parrainage)",
      student_placeholder: "Nom complet ou niveau de classe",
      message_placeholder: "Votre message (facultatif)",
      submit: "Envoyer mon engagement",
      success: "Merci ! Nous vous recontacterons pour la suite.",
    },
    contact: {
      overline: "Contact",
      title: "Nous serions ravis de vous entendre.",
      email: "icdh@ecoleicdh.org", email2: "icdhhaiti@gmail.com",
      locations: [
        { name: "Siège 1 · Haïti", address: "34 Mahotière 83, Carrefour, Port-au-Prince, Haïti", phone: "+509 34 33 21 33" },
        { name: "ICDH Plaza · Haïti", address: "Ruelle Baguidy (en face Côte Plage 16) — ICDH Plaza, Carrefour", phone: "+509 34 33 21 33" },
        { name: "Bureau USA", address: "2910 Glenwood Road, Brooklyn, NY 11210, USA", phone: "+1 (718) 421-3349" },
      ],
      form: { name: "Nom", email: "Courriel", message: "Message", submit: "Envoyer le message", success: "Message envoyé. Merci !" },
    },
    footer: {
      tagline: "Former les leaders de demain.",
      rights: "Tous droits réservés.",
      quick: "Explorer",
      contact: "Contact",
      partners: "Partenaires & Presse",
    },
    parents: {
      title: "Portail Parents & Élèves",
      welcome: "Bienvenue",
      subtitle: "Accédez au compte de votre élève, aux factures, aux notes et à la communication scolaire.",
      pay_title: "Payer les frais de scolarité via Zelle",
      pay_body: "Scannez le code QR ci-dessous avec votre application Zelle pour compléter le paiement. Envoyez la confirmation à icdhhaiti@gmail.com.",
      scan: "Scannez pour payer",
      invoice: { t: "Facture de scolarité", d: "Votre dernière facture apparaîtra ici une fois publiée par le service financier." },
      grades: { t: "Notes & Relevé non officiel", d: "Les notes les plus récentes et le relevé non officiel de votre élève." },
      projects: { t: "Projets", d: "Liste des projets et devoirs actifs." },
      reminders: { t: "Rappels & Notes", d: "Notes et rappels des enseignants et de l'administration." },
      homework: { t: "Devoirs (Élèves)", d: "Connectez-vous pour voir les devoirs des enseignants et les informations pertinentes." },
      message_title: "Écrire à l'école",
      message_placeholder: "Écrivez à l'administration ou à l'enseignant de votre élève…",
      pending: "Bientôt disponible — l'école publiera du contenu ici sous peu.",
      admin_link: "Aller au tableau de bord Admin",
      logout: "Déconnexion",
      broadcasts_title: "Communications de l'école",
      broadcasts_empty: "Aucune communication de l'école pour le moment.",
      from_school: "De la part de l'école",
    },
    login: {
      title: "Connexion",
      sub: "Parents, élèves et personnel.",
      email: "Courriel",
      password: "Mot de passe",
      submit: "Se connecter",
      back: "Retour au site",
    },
  },
};
